import { ReportMxData } from '../../../types';

interface Props {
  title: string;
  value?: number;
  label?: string;
  disabled?: boolean;
  reportColumnName: string;
  setReportMxData: (reportMxData: ReportMxData | ((prev: ReportMxData | null) => ReportMxData)) => void; // 함수형 업데이트 지원
}

const InputGroup = ({ title, value = 0, label = '', disabled, reportColumnName, setReportMxData }: Props) => {
  /**
   *
   */
  const handleOnChange = ({ target }: React.ChangeEvent<HTMLSelectElement>) => {
    setReportMxData((report: ReportMxData) => ({
      ...report, //
      [reportColumnName]: parseInt(target.value),
    }));
  };

  return (
    <div className="styled-group">
      <span className="styled-left">{title}</span>
      <select //
        className="styled-right"
        aria-label={label}
        onChange={handleOnChange}
        value={value}
        disabled={disabled}
      >
        {Array.from(Array(100).keys(), (_, i) => {
          return <option key={i}>{_}</option>;
        })}
      </select>
    </div>
  );
};

export default InputGroup;
